import { Link, useLocation } from "react-router-dom";
import { CalendarDays, Crown, Gamepad2, Home, Ticket } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { usePlatform } from "@/contexts/PlatformContext";

const APP_ROUTES = [
  { path: "/", label: "Início", icon: Home, match: (pathname) => pathname === "/" },
  { path: "/eventos", label: "Eventos", icon: CalendarDays, match: (pathname) => pathname.startsWith("/eventos") },
  { path: "/jogos", label: "Jogar", icon: Gamepad2, match: (pathname) => pathname.startsWith("/jogos"), featured: true },
  { path: "/clube", label: "Clube", icon: Crown, match: (pathname) => pathname.startsWith("/clube") || pathname.startsWith("/meu-plano") || pathname.startsWith("/beneficios") },
];

const HIDE_ON_ROUTES = [
  "/admin",
  "/promotor",
  "/estabelecimento",
  "/reset-password",
];

export default function MobileBottomNav() {
  const location = useLocation();
  const { user } = useAuth();
  const { isApp } = usePlatform();

  if (
    !isApp ||
    HIDE_ON_ROUTES.some((route) => location.pathname.startsWith(route)) ||
    location.pathname.startsWith("/quiz-especial/") ||
    !user
  ) {
    return null;
  }

  const items = [
    ...APP_ROUTES,
    {
      path: "/meus-ingressos",
      label: "Carteira",
      icon: Ticket,
      match: (pathname) => pathname.startsWith("/meus-ingressos") || pathname.startsWith("/perfil"),
    },
  ];

  return (
    <div
      className="lg:hidden fixed inset-x-0 bottom-0 z-50 px-3 pb-3 pointer-events-none"
      style={{ paddingBottom: "max(12px, env(safe-area-inset-bottom))" }}
    >
      <div className="mx-auto max-w-md pointer-events-auto rounded-[24px] border border-zinc-800 bg-zinc-950 shadow-[0_-10px_30px_rgba(0,0,0,0.55)]">
        <div className="grid grid-cols-5 gap-1 p-2">
          {items.map((item) => {
            const Icon = item.icon;
            const isActive = item.match(location.pathname);

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex min-h-[64px] flex-col items-center justify-center gap-1 rounded-2xl transition-all ${
                  isActive
                    ? "bg-[#fccf1f] text-black shadow-[0_8px_24px_rgba(252,207,31,0.22)]"
                    : item.featured
                    ? "border border-[#fccf1f]/30 bg-zinc-900 text-[#fccf1f] shadow-[0_8px_24px_rgba(252,207,31,0.08)]"
                    : "text-zinc-400 hover:bg-zinc-900 hover:text-white"
                }`}
                data-testid={`mobile-bottom-${item.label.toLowerCase()}`}
              >
                <Icon className={`h-5 w-5 ${item.featured && !isActive ? "scale-110" : ""}`} />
                <span className={`font-outfit text-[11px] font-medium ${item.featured && !isActive ? "font-bold" : ""}`}>
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
